import config from '../config/config';

// Configuration utility functions
export const configUtils = {
  // Get API endpoint
  getApiEndpoint: (category, endpoint) => {
    return config.API_ENDPOINTS[category]?.[endpoint] || '';
  },

  // Get full API URL
  getFullApiUrl: (endpoint) => {
    return `${config.API_BASE_URL}${endpoint}`;
  },

  // Get storage key
  getStorageKey: (key) => {
    return config[key] || key;
  },

  // Check if feature is enabled
  isFeatureEnabled: (feature) => {
    return config[`ENABLE_${feature.toUpperCase()}`] === true;
  },

  // Get UI configuration
  getUIConfig: () => {
    return {
      theme: config.THEME,
      primaryColor: config.PRIMARY_COLOR,
      secondaryColor: config.SECONDARY_COLOR,
    };
  },

  // Get file upload configuration
  getFileUploadConfig: () => {
    return {
      maxSize: config.MAX_FILE_SIZE,
      allowedTypes: config.ALLOWED_FILE_TYPES,
    };
  },

  // Get pagination configuration
  getPaginationConfig: () => {
    return {
      defaultPageSize: config.DEFAULT_PAGE_SIZE,
      maxPageSize: config.MAX_PAGE_SIZE,
    };
  },

  // Get toast configuration
  getToastConfig: () => {
    return {
      duration: config.TOAST_DURATION,
      position: config.TOAST_POSITION,
    };
  },

  // Check if in development mode
  isDevelopment: () => {
    return config.IS_DEVELOPMENT;
  },

  // Check if in production mode
  isProduction: () => {
    return config.IS_PRODUCTION;
  },

  // Get app information
  getAppInfo: () => {
    return {
      name: config.APP_NAME,
      version: config.APP_VERSION,
      description: config.APP_DESCRIPTION,
    };
  },

  // Log configuration (only in development)
  logConfig: () => {
    if (config.IS_DEVELOPMENT && config.ENABLE_DEBUG) {
      console.log('🔧 Frontend Configuration:', config);
    }
  }
};

// Export individual functions for convenience
export const {
  getApiEndpoint,
  getFullApiUrl,
  getStorageKey,
  isFeatureEnabled,
  getUIConfig,
  getFileUploadConfig,
  getPaginationConfig,
  getToastConfig,
  isDevelopment,
  isProduction,
  getAppInfo,
  logConfig
} = configUtils;

export default configUtils;
